import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/dividend-yield-calculator',
  component: () => import('../../routes/DividendYieldCalculator.svelte'),
  card: {
    id: 'dividend-yield',
    title: 'Dividend Yield Calculator',
    description: 'Calculate dividend yield, monthly/quarterly income, and cost per dollar of annual dividend income for dividend-paying stocks.',
    icon: 'trending_up',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/dividend-yield-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Dividend Yield Calculator — Calculate Yield, Monthly Income & Cost Per Dollar',
    description: 'Free dividend yield calculator: compute annual yield %, monthly and quarterly dividend income, and cost to generate $1 of annual dividend income.',
  },
};

export default meta;